import { useState, useEffect } from "react";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";
import { isPWA, isMobilePWA } from "../../utils/pwa";
import { isWebView } from "../../utils/webview";
import "../../styles/pwa-customers.css";


const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [countryDrp, setCountryDrpData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [error, setError] = useState([]);
  const [pwaMode, setPwaMode] = useState(false);
  const [mobilePWA, setMobilePWA] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isMobile, setIsMobile] = useState(false);
  const [webViewMode, setWebViewMode] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    image: "",
    image_url: "",
    address: "",
    gst_no: "",
    email: "",
    contact_no: "",
    pincode: "",
    website: "",
    password: "",
    country_id: "",
    city_id: "",
    state_id: "",
  });

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: formData.country_id })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formData.state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (isInvalid(formData.name)) {
      toast.error("Name Is Required");
      return false;
    }
    if (isInvalid(formData.email)) {
      toast.error("Email Is Required");
      return false;
    }
    if (isInvalid(formData.contact_no)) {
      toast.error("Contact Number Is Required");
      return false;
    }
    setError([]);
    setLoading(true);
    let url = API_URL.SAVE_USER;
      axios.post(url, formData).then(
        (response) => {
          setLoading(false);
          if (response.data.status === 1) {
            toast.success("Setting Updated Successfully", { autoClose: 3000 });
          } else {
            if (response.data && response.data.data) {
              let errors = [];
              Object.keys(response.data.data).forEach((key) => {
                errors.push(response.data.data[key][0]);
              });
              setError(errors);
              toast.error("Something went wrong..", { autoClose: 3000 });
            }
          }
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  const getUser = () => {
    axios.post(API_URL.LOGIN_USER).then((response) => {
      if (response.data.data) {
        setFormData({
          name: response.data.data.name || "",
          address: response.data.data.address || "",
          email: response.data.data.email || "",
          image: "",
          contact_no: response.data.data.contact_no || "",
          country_id: response.data.data.country_id || "",
          city_id: response.data.data.city_id || "",
          state_id: response.data.data.state_id || "",
          gst_no: response.data.data.gst_no || "",
          pincode: response.data.data.pincode || "",
          website: response.data.data.website || "",
        });
        if (response.data.data.image) {
          setImagePreview(response.data.data.image)
        }
        
      }
    });
  };

  const isInvalid = (value) => {
    return !value || value === "" || value === null;
  };

  // Handle online/offline status
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (pwaMode) {
        toast.success("Connection restored", { autoClose: 2000 });
      }
    };
    
    const handleOffline = () => {
      setIsOnline(false);
      if (pwaMode) {
        toast.warning("You're offline. Some features may not work.", { autoClose: 3000 });
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [pwaMode]);

  useEffect(() => {
    getCountryDrpData();
    // Check PWA mode, mobile, and webview
    setPwaMode(isPWA());
    setMobilePWA(isMobilePWA());
    setIsMobile(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    setWebViewMode(isWebView());
  }, []);

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    getStateDrpData();
  }, [formData.country_id]);

  useEffect(() => {
    getCityDrpData();
  }, [formData.state_id]);

  return (
    <>
      {/* PWA Header - Only show in PWA mode or mobile (not webview) */}
      {(pwaMode || (isMobile && !webViewMode)) && (
        <div className="pwa-header bg-primary text-white p-3 mb-3">
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">
              <i className="simple-icon-user me-2"></i>
              Profile Settings
            </h4>
            <div className="d-flex align-items-center gap-2">
              {!isOnline && (
                <div className="pwa-status-indicator bg-warning">
                  <i className="simple-icon-wifi me-1"></i>
                  Offline
                </div>
              )}
              {mobilePWA && (
                <div className="pwa-status-indicator">
                  <i className="simple-icon-screen-smartphone me-1"></i>
                  PWA
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      
      <div className={`row ${(pwaMode || (isMobile && !webViewMode)) ? 'pwa-content' : ''}`}>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              {!(pwaMode || (isMobile && !webViewMode)) && (
                <h4 className="card-title">Contact Detail</h4>
              )}
              {webViewMode && (
                <small className="text-muted mb-3 d-block">
                  <i className="simple-icon-screen-smartphone me-1"></i>
                  WebView Mode
                </small>
              )}
              <form onSubmit={onSubmit}>
                <div className="">
                  {(pwaMode || (isMobile && !webViewMode)) ? (
                    // PWA Mobile Layout
                    <div className="pwa-profile-form">
                      {/* Profile Image Section */}
                      <div className="pwa-profile-image-section mb-4">
                        <div className="text-center">
                          <div className="pwa-profile-image-container">
                            <Crop
                              imagePreview={imagePreview}
                              cropShape={"rect"}
                              aspectRatio={'BLOG'}
                              guid={""}
                              width={200}
                              height={120}
                              onChangeCropper={async ({
                                fileCropped,
                                fileCroppedBase64,
                              }) => {
                                setFormData({
                                  ...formData,
                                  image: fileCroppedBase64,
                                });
                                setImagePreview(fileCroppedBase64);
                              }}
                            />
                          </div>
                          <small className="text-muted mt-2 d-block">Tap to change profile image</small>
                        </div>
                      </div>

                      {/* Form Fields */}
                      <div className="pwa-form-fields">
                        <div className="row">
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Name *</label>
                              <input
                                className="form-control form-control-lg"
                                name="name"
                                type="text"
                                value={formData.name ?? ""}
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    name: event.target.value,
                                  });
                                }}
                                placeholder="Enter your name"
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Email *</label>
                              <input
                                className="form-control form-control-lg"
                                name="email"
                                type="email"
                                value={formData.email ?? ""}
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    email: event.target.value,
                                  });
                                }}
                                placeholder="Enter your email"
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Mobile Number *</label>
                              <input
                                className="form-control form-control-lg"
                                name="contact_no"
                                type="tel"
                                value={formData.contact_no ?? ""}
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    contact_no: event.target.value,
                                  });
                                }}
                                placeholder="Enter your mobile number"
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Address</label>
                              <textarea
                                className="form-control form-control-lg"
                                name="address"
                                rows="3"
                                value={formData.address ?? ""}
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    address: event.target.value,
                                  });
                                }}
                                placeholder="Enter your address"
                              />
                            </div>
                          </div>
                          
                          <div className="col-6 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Pin Code</label>
                              <input
                                type="number"
                                name="pincode"
                                maxLength={30}
                                value={formData.pincode}
                                className="form-control form-control-lg"
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    pincode: event.target.value,
                                  });
                                }}
                                placeholder="Pin code"
                              />
                            </div>
                          </div>
                          
                          <div className="col-6 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">GST Number</label>
                              <input
                                className="form-control form-control-lg"
                                name="gst_no"
                                type="text"
                                value={formData.gst_no ?? ""}
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    gst_no: event.target.value,
                                  });
                                }}
                                placeholder="GST number"
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Website</label>
                              <input
                                type="url"
                                name="website"
                                value={formData.website}
                                className="form-control form-control-lg"
                                onChange={(event) => {
                                  setFormData({
                                    ...formData,
                                    website: event.target.value,
                                  });
                                }}
                                placeholder="https://yourwebsite.com"
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">Country</label>
                              <Select
                                placeholder="Select Country"
                                options={countryDrp}
                                value={countryDrp.find(
                                  (r) => r.value == formData.country_id
                                )}
                                styles={{
                                  ...styles,
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '48px',
                                    fontSize: '16px'
                                  })
                                }}
                                onChange={(e) =>
                                  setFormData({ ...formData, country_id: e.value })
                                }
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">State</label>
                              <Select
                                placeholder="Select State"
                                options={stateDrp}
                                value={stateDrp.find(
                                  (r) => r.value == formData.state_id
                                )}
                                styles={{
                                  ...styles,
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '48px',
                                    fontSize: '16px'
                                  })
                                }}
                                onChange={(e) =>
                                  setFormData({ ...formData, state_id: e.value })
                                }
                              />
                            </div>
                          </div>
                          
                          <div className="col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label fw-bold">City</label>
                              <Select
                                placeholder="Select City"
                                options={cityDrp}
                                value={cityDrp.find(
                                  (r) => r.value == formData.city_id
                                )}
                                styles={{
                                  ...styles,
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '48px',
                                    fontSize: '16px'
                                  })
                                }}
                                onChange={(e) =>
                                  setFormData({ ...formData, city_id: e.value })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    // Original Desktop Layout
                    <div className="d-flex">
                      <div className="me-4">
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Image</label>
                                <Crop
                                  imagePreview={imagePreview}
                                  cropShape={"rect"}
                                  aspectRatio={'BLOG'}
                                  guid={""}
                                  width={250}
                                  height={150}
                                  onChangeCropper={async ({
                                    fileCropped,
                                    fileCroppedBase64,
                                  }) => {
                                    setFormData({
                                      ...formData,
                                      image: fileCroppedBase64,
                                    });
                                    setImagePreview(fileCroppedBase64);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Name</label>
                            <input
                              className="form-control"
                              name="title"
                              type="text"
                              value={formData.name ?? ""}
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  name: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Address</label>
                            <input
                              className="form-control"
                              name="title"
                              type="text"
                              value={formData.address ?? ""}
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  address: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              className="form-control"
                              name="title"
                              type="text"
                              value={formData.email ?? ""}
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  email: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Mobile Number</label>
                            <input
                              className="form-control"
                              name="title"
                              type="text"
                              value={formData.contact_no ?? ""}
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  contact_no: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="name">Pin Code</label>
                            <input
                              type="number"
                              name="Pin code"
                              maxLength={30}
                              value={formData.pincode}
                              className="form-control"
                              id="Pin code"
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  pincode: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Country">Country</label>
                            <Select
                              placeholder="Select Country"
                              options={countryDrp}
                              value={countryDrp.find(
                                (r) => r.value == formData.country_id
                              )}
                              styles={styles}
                              onChange={(e) =>
                                setFormData({ ...formData, country_id: e.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="State">State</label>
                            <Select
                              placeholder="Select State"
                              options={stateDrp}
                              value={stateDrp.find(
                                (r) => r.value == formData.state_id
                              )}
                              styles={styles}
                              onChange={(e) =>
                                setFormData({ ...formData, state_id: e.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="City">City</label>
                            <Select
                              placeholder="Select City"
                              options={cityDrp}
                              value={cityDrp.find(
                                (r) => r.value == formData.city_id
                              )}
                              styles={styles}
                              onChange={(e) =>
                                setFormData({ ...formData, city_id: e.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Gst Number</label>
                            <input
                              className="form-control"
                              name="title"
                              type="text"
                              value={formData.gst_no ?? ""}
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  gst_no: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="name">Website</label>
                            <input
                              type="text"
                              name="website"
                              value={formData.website}
                              className="form-control"
                              id="website"
                              onChange={(event) => {
                                setFormData({
                                  ...formData,
                                  website: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Submit Button */}
                  <div className="col-md-12 text-right">
                    <div className="text-end">
                      <button 
                        type="submit" 
                        className={`btn btn-primary ${(pwaMode || (isMobile && !webViewMode)) ? 'btn-lg w-100' : ''}`}
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Update Profile"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
